import axios from 'axios'
import { castAttributesForCamelCase } from '../../modules/string_converter'
import { i18n } from '../../plugins/i18n'

export const companiesServicePatterns = {
  namespaced: true,
  state: {
    servicePatterns: null,
    servicePatternLoading: false,
    stores: null,
    storeLoading: false,
  },
  mutations: {
    readServicePatterns(state) {
      state.servicePatternLoading = true
    },
    readServicePatternsSuccess(state, payload) {
      state.servicePatterns = payload.data.map(i => castAttributesForCamelCase(i))
      state.servicePatternLoading = false
    },
    readServicePatternsFailure(state) {
      state.servicePatternLoading = false
    },
    deleteServicePattern(state) {
      state.servicePatternLoading = true
    },
    deleteServicePatternSuccess(state, id) {
      state.servicePatterns = state.servicePatterns.map(category => ({
        ...category,
        servicePatterns: category.servicePatterns.filter(pattern => pattern.id !== id)
      }))
      state.servicePatternLoading = false
    },
    deleteServicePatternFailure(state) {
      state.servicePatternLoading = false
    },
    readServicePatternStores(state) {
      state.storeLoading = true
    },
    readServicePatternStoresSuccess(state, payload) {
      state.stores = payload.data.map(i => castAttributesForCamelCase(i))
      state.storeLoading = false
    },
    readServicePatternStoresFailure(state) {
      state.storeLoading = false
    },
  },
  actions: {
    readServicePatterns({ commit, rootState }) {
      commit('readServicePatterns')
      return axios
        .get(`/api/companies/${ rootState.route.params.company_uuid }/service_patterns`)
        .then(res => {
          commit('readServicePatternsSuccess', res.data)
        })
        .catch(err => {
          commit('eadServicePatternsFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    deleteServicePattern({ commit, rootState }, id) {
      commit('deleteServicePattern')
      return axios
        .delete(`/api/companies/${ rootState.route.params.company_uuid }/service_patterns/${ id }`)
        .then(() => {
          commit('deleteServicePatternSuccess', id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.servicePattern.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('deleteServicePatternFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
    readServicePatternStores({ commit, rootState }, id) {
      commit('readServicePatternStores')
      return axios
        .get(`/api/companies/${ rootState.route.params.company_uuid }/service_patterns/${ id }/stores`)
        .then(res => {
          commit('readServicePatternStoresSuccess', res.data)
        })
        .catch(err => {
          commit('readServicePatternStoresFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
